import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common';
import { AppDatePipe } from 'src/app/shared/pipes/app-date.pipe';

@Component({
  standalone: true,
  imports: [CommonModule, AppDatePipe],
  selector: 'app-birthday-card',
  templateUrl: './birthday-card.component.html',
  styleUrl: './birthday-card.component.scss'
})
export class BirthdayCardComponent {
  @Input() userName:string='';
  @Input() userPost:string='';
  @Input() discription: string='';
  @Input() imageUrl: string = '';
  @Input() datePost: string = '';
}
